import sets from '../sets';
import prefill from '../prefill';

export default prefill({
  0: {},
  1: { price: 2, set: sets.facialHair },
  2: { price: 2, set: sets.facialHair },
});
